// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"MobileApplicationHeader_stickyHeader__4HQ96","scrolled":"MobileApplicationHeader_scrolled__yqng2","title":"MobileApplicationHeader_title__3dECc"};